export const downloadFile = function (url) {
  window.open(url, 'Download');
};
